export default "<p-menubar *ngIf=\"showMenuBar\" [model]=\"items\" styleClass=\"{{styleClass}}\" [autoDisplay]=\"false\"></p-menubar>\n"